import React, { useReducer, useState, useEffect } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Space,
  Card,
  DatePicker,
  Select,
  Input,
  Button,
  Modal,
  notification,
} from "antd";
import { NavLink } from "react-router-dom";
import { getServerUrl } from "../../config";
import axios from "axios";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
const { Option } = Select;
const initialList = [];
const initialrawList = [];
const initialChildComponentList = [];
const ViewComponent = (props) => {
  const { id } = props.match.params;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [componentType, setcomponentType] = useState("");
  const [process, setprocess] = useState([""]);
  const [rawmaterial, setrawmaterial] = useState([""]);
  const [componentfamily, setcomponentfamily] = useState([""]);
  const [subcomponent, setsubcomponent] = useState([""]);
  const [componentfamilyvalue, setcomponentfamilyvalue] = useState([""]);
  const [rawmaterialvariant, setrawmaterialvariant] = useState([""]);
  const [rawmaterialvariantname, setrawmaterialvariantname] = useState([""]);
  const [rawmaterialname, setrawmaterialname] = useState("");
  const [ProcessList, setProcessList] = useState([""]);
  const [list, setList] = React.useState(initialList);
  const [rawList, setrawList] = React.useState(initialrawList);
  const [ChildName, setChildName] = useState("");
  const [ChildComponentList, setChildComponentList] = React.useState(
    initialChildComponentList
  );
  const [componentfamilyName, setcomponentfamilyName] = React.useState("");
  const [userInput, setUserInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      component_id: "",
      component_name: "",
      component_description: "",
      component_type: "",
      component_number: "",
      component_family: "",
      child_component: "",
      process_name: "",
      process_realname: "",
      process_desc: "",
      operation_order: "",
      process: "",
      childcomponent: "",
      rawmaterial_name: "",
      rawmaterial_variant: "",
      rawmaterial_length: "",
      rawmaterial_weight: "",
      rawmaterialvariantname: "",
      raw_material_diameter: "",
      child_component_quantity: "",
    }
  );

  useEffect(() => {
    axios
      .get(`${getServerUrl()}/master/component/${id}`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        const details = res.data;
        if (res.data.success === 1) {
          setUserInput({
            component_id: details.data.component_id,
            component_name: details.data.component_name,
            component_description: details.data.component_desc,
            component_type: details.data.component_type,
            component_number: details.data.component_no,
            component_family: details.data.component_family,
            component_price: details.data.component_price,
            child_component: details.data.child_component,
            process_name: details.data.process_name,
            process_realname: details.data.process_realname,
            process: details.data.component_name,
            childcomponent: details.data.component_name,
            rawmaterial_name: details.data.rawmaterial,
            rawmaterial_variant: details.data.rawmaterial_diameter,
            rawmaterial_length: details.data.rawmaterial_length,
            rawmaterial_weight: details.data.rawmaterial_weight,
            rawmaterialvariantname: details.data.rawmaterialvariantname,
            raw_material_diameter: details.data.rawmaterial_diameter,
            child_component_quantity: details.data.child_component_quantity,
          });
          setcomponentfamilyvalue(details.data.component_family);
          setcomponentType(details.data.component_type);
          axios
            .get(
              `${getServerUrl()}/master/rawmaterial/${
                details.data.rawmaterial
              }`,
              {
                headers: { "x-auth-token": localStorage.getItem("token") },
              }
            )
            .then((res) => {
              const details = res.data;
              console.log("details", details.data.raw_material_name);
              setrawmaterialname(details.data.raw_material_name);
            });
          axios
            .get(
              `${getServerUrl()}/master/componentfamily/${
                details.data.component_family
              }`,
              {
                headers: { "x-auth-token": localStorage.getItem("token") },
              }
            )
            .then((res) => {
              let responsevalue = Object.values(res.data);
              const details = responsevalue;
              details.map((detail) => {
                console.log("component_family", detail);
                setcomponentfamilyName(detail.component_family);
              });
            });
        } else {
          window.location.href = "/components-list";
        }
      });
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const newValue = e.target.value;
    setUserInput({ [name]: newValue });
  };

  function selecthandleChange(value) {
    setcomponentType(value);
    setChildComponentList([]);
    setList([]);
  }

  function selectComponentFamilyChange(value) {
    setcomponentfamilyvalue(value);
    axios
      .get(`${getServerUrl()}/master/componentfamily/${value}`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = Object.values(res.data);
        const details = responsevalue;
        details.map((detail) => {
          console.log("component_family", detail);
          setcomponentfamilyName(detail.component_family);
        });
      });
  }

  function processChange(value) {
    userInput.process_name = value;
    axios
      .get(`${getServerUrl()}/master/process/${value}`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = Object.values(res.data);
        const details = responsevalue;
        details.map((detail) => {
          //console.log("detail.process_name", detail.process_name);
          userInput.process_realname = detail.process_name;
        });
      });
  }

  function rawvariantChange(value) {
    userInput.raw_material_diameter = value;
  }

  function childComponentChange(value) {
    userInput.child_component = value;
    axios
      .get(`${getServerUrl()}/master/component/${userInput.child_component}`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        const details = res.data;
        setChildName(
          details.data.component_no + " | " + details.data.component_name
        );
      });
  }

  function rawChange(value) {
    axios
      .get(`${getServerUrl()}/master/rawmaterial/${value}`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = Object.values(res.data);
        const details = responsevalue;
        details.map((detail) => {
          if (detail.raw_material_diameter) {
            setrawmaterialvariantname(detail.raw_material_name);
            setrawmaterialvariant(detail.raw_material_diameter.split(","));
          }
        });
      });
    userInput.rawmaterial_name = value;
    userInput.rawmaterialvariantname = rawmaterialvariantname;
    setrawmaterialname(value);
  }

  /* Child Component Change */

  const insertChildComponent = () => {
    if (
      userInput.child_component !== "" &&
      userInput.child_component_quantity
    ) {
      if (
        !ChildComponentList.some(
          (item) => item.child_component === userInput.child_component
        )
      ) {
        setChildComponentList(
          ChildComponentList.concat({
            id: Date.now(),
            child_component: userInput.child_component,
            child_name: ChildName,
            child_component_quantity: userInput.child_component_quantity,
          })
        );
      }

      userInput.child_component = "";
      userInput.child_component_quantity = "";
    }
  };
  const deleteComponent = (id) => {
    setChildComponentList(ChildComponentList.filter((item) => item.id !== id));
  };

  /* Process List */
  /* Initial Process */
  /* Component Process List */
  useEffect(async () => {
    await axios
      .get(`${getServerUrl()}/master/componentprocess/${id}`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = Object.values(res.data.data);
        const details = responsevalue;
        setList(details);
      });
  }, []);

  useEffect(async () => {
    await axios
      .get(`${getServerUrl()}/master/getchildcompoent/${id}`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = Object.values(res.data.data);
        const details = responsevalue;
        setChildComponentList(details);
      });
  }, []);

  const insertProcess = () => {
    if (userInput.process_name !== "" && userInput.operation_order !== "") {
      setList(
        list.concat({
          id: Date.now(),
          processid: userInput.process_name,
          processname: userInput.process_realname,
          processdesc: userInput.process_desc,
          rorder: Number(userInput.operation_order),
        })
      );
      userInput.process_name = "";
      userInput.process_desc = "";
      userInput.operation_order = "";
    }
  };

  const handleClick = (id) => {
    setList(list.filter((item) => item.id !== id));
  };
  const rawdelete = (id) => {
    setrawList(rawList.filter((item) => item.id !== id));
  };
  const orderUp = (id, order) => {
    if (Number(order) < 0) {
      order = 1;
    }
    setList(
      list.map((item) => {
        if (item.id === id) {
          return { ...item, rorder: Number(order) - 10 };
        } else {
          return item;
        }
      })
    );
  };
  const orderDown = (id, order) => {
    console.log(order);
    if (Number(order) < 0) {
      order = 0;
    }
    setList(
      list.map((item) => {
        if (item.id === id) {
          return { ...item, rorder: Number(order) + 10 };
        } else {
          return item;
        }
      })
    );
  };

  /* Process List */
  useEffect(() => {
    axios
      .get(`${getServerUrl()}/master/process`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = Object.values(res.data.data);
        const details = responsevalue;
        setprocess(details);
      });
  }, []);

  /* Raw Material */

  useEffect(() => {
    axios
      .get(`${getServerUrl()}/master/rawmaterial`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = Object.values(res.data.data);
        const details = responsevalue;
        //console.log(details);
        setrawmaterial(details);
      });
  }, []);

  /* Component Family */
  useEffect(() => {
    axios
      .get(`${getServerUrl()}/master/componentfamily`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = Object.values(res.data.data);
        const details = responsevalue;
        //console.log(details);
        setcomponentfamily(details);
      });
  }, []);

  /* Component Family */
  useEffect(() => {}, []);

  /* Raw Material Name */
  useEffect(() => {}, []);

  /* Child Component */
  useEffect(() => {
    axios
      .get(`${getServerUrl()}/master/childcomponent`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = Object.values(res.data.data);
        const details = responsevalue;
        //console.log(details);
        setsubcomponent(details);
      });
  }, []);

  /* Fill Drop Down */
  const dropDownOptions = process.map((dataDrop) => {
    return <Option value={dataDrop.process_id}>{dataDrop.process_name}</Option>;
  });
  const rawOptions = rawmaterial.map((dataDrop) => {
    return (
      <Option value={dataDrop.raw_material_id}>
        {dataDrop.raw_material_name}
      </Option>
    );
  });
  const ComponentFamilyOptions = componentfamily.map((dataDrop) => {
    return <Option value={dataDrop.cf_id}>{dataDrop.component_family}</Option>;
  });

  const childComponentOptions = subcomponent.map((dataDrop) => {
    return (
      <Option value={dataDrop.component_id}>
        {dataDrop.component_no} | {dataDrop.component_name}
      </Option>
    );
  });
  const rawvariantOptions = rawmaterialvariant.map((dataDrop) => {
    return <Option value={dataDrop}>{dataDrop}</Option>;
  });

  /* Open Notifications */
  const openNotification = (type) => {
    notification[type]({
      message: "Component Updated",
      description: "Component update successfully",
    });
  };
  const FailNotification = (type) => {
    notification[type]({
      message: "Error",
      description: "Please Fill out Required Fields",
    });
  };

  /* Submit Form */

  const handleSubmit = (e) => {
    userInput.process = list;
    userInput.component_family = componentfamilyvalue;
    userInput.component_type = componentType;
    userInput.childcomponent = ChildComponentList;
    console.log("formSubmit", userInput);
    e.preventDefault();
    if (userInput.component_type === "Child Component") {
      userInput.childcomponent = "";
      if (userInput.component_family !== "") {
        axios
          .post(`${getServerUrl()}/master/updatecomponent`, userInput, {
            headers: { "x-auth-token": localStorage.getItem("token") },
          })
          .then((res) => {
            const data = res.data;
            ////console.log(data);
            if (data.success === 1) {
              setUserInput({
                component_family: "",
              });
              openNotification("success");
              window.location.reload();
            } else {
            }
          });
      } else {
        FailNotification("error");
      }
    } else {
      userInput.rawmaterial_name = "";
      userInput.raw_material_diameter = "";
      userInput.rawmaterial_length = "";
      userInput.rawmaterial_weight = "";
      if (
        userInput.component_family !== "" &&
        userInput.component_name !== ""
      ) {
        axios
          .post(`${getServerUrl()}/master/updatecomponent`, userInput, {
            headers: { "x-auth-token": localStorage.getItem("token") },
          })
          .then((res) => {
            const data = res.data;
            ////console.log(data);
            if (data.success === 1) {
              setUserInput({
                component_family: "",
              });
              openNotification("success");
              window.location.reload();
            } else {
            }
          });
      } else {
        FailNotification("error");
      }
    }
  };

  /* Complete Action */

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Master Settings </Breadcrumb.Item>
        <Breadcrumb.Item>Components Settings</Breadcrumb.Item>
        <Breadcrumb.Item>Update Component</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background">
        <h2 className="titles">
          CREATE NEW <span>COMPONENT</span>
        </h2>

        <Row>
          <Col span={16}>
            <h2>Component Name</h2>
            <label>Component Type</label>
            <br></br>
            <Input type="hidden" value={userInput.component_id} />
            <Select
              name="contractor_type"
              onChange={selecthandleChange}
              placeholder="Please Select Contractor Type"
              style={{ width: "250px" }}
              value={componentType}
              disabled
            >
              <Option value="Parent Component">Parent Component</Option>
              <Option value="Child Component">Child Component</Option>
            </Select>
            <br></br>
            <label>Component Family</label>
            <br></br>
            <Select
              name="component_family"
              onChange={selectComponentFamilyChange}
              placeholder="Please Select Component"
              select={componentfamilyvalue}
              value={componentfamilyName}
              style={{ width: "250px" }}
            >
              {ComponentFamilyOptions}
            </Select>
            <br></br>
            <label>Component Name</label>
            <Input
              name="component_name"
              value={userInput.component_name}
              onChange={handleChange}
            />
            <label>Component No.</label>
            <Input
              name="component_number"
              value={userInput.component_number}
              onChange={handleChange}
            />
            <label>Component Description</label>
            <Input
              name="component_description"
              value={userInput.component_description}
              onChange={handleChange}
            />
            <label>Component Price</label>
            <Input
              name="component_price"
              value={userInput.component_price}
              onChange={handleChange}
            />
          </Col>
        </Row>
      </div>

      <div
        className={
          componentType === "Parent Component"
            ? "site-layout-background"
            : "site-layout-background display-none"
        }
      >
        <Row>
          <Col span={16}>
            <h2>Child Component(s)</h2>
            <Select
              name="sub_component"
              placeholder="Please Select Component"
              style={{ width: "250px" }}
              onChange={childComponentChange}
            >
              {childComponentOptions}
            </Select>
            <br></br>
            <label>Quantity</label>
            <Input
              name="child_component_quantity"
              value={userInput.child_component_quantity}
              onChange={handleChange}
            />

            <br></br>
            <Button
              type="primary"
              shape="round"
              size="large"
              onClick={insertChildComponent}
            >
              Add Child Component
            </Button>
            <br></br>
            <ul className="processOrder">
              {ChildComponentList.map((item) => (
                <li key={item.id}>
                  <div className="processBar">
                    <div className="content">{item.child_name}</div>
                    <div className="content">
                      {item.child_component_quantity}
                    </div>
                    <div>
                      <button onClick={() => deleteComponent(item.id)}>
                        X
                      </button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </div>
      <div
        className={
          componentType === "Child Component"
            ? "site-layout-background"
            : "site-layout-background display-none"
        }
      >
        <Row>
          <Col span={16}>
            <h2>Raw Material Details</h2>
            <label>Select Raw Material</label>
            <br></br>
            <Select
              name="rawmaterial_name"
              onChange={rawChange}
              placeholder="Please Select Rawmaterial"
              value={rawmaterialname}
              style={{ width: "250px" }}
            >
              {rawOptions}
            </Select>
            <br></br>
            <label>Diameter</label>
            <br></br>
            <Select
              name="rawmaterial_variant"
              onChange={rawvariantChange}
              value={userInput.raw_material_diameter}
              placeholder="Please Select Diameter"
              style={{ width: "250px" }}
            >
              {rawvariantOptions}
            </Select>
            <br></br>
            <label>Component Length</label>
            <Input
              name="rawmaterial_length"
              value={userInput.rawmaterial_length}
              onChange={handleChange}
            />
            <label>Component Weight </label>
            <Input
              name="rawmaterial_weight"
              value={userInput.rawmaterial_weight}
              onChange={handleChange}
            />
          </Col>
        </Row>
      </div>
      <div className="site-layout-background">
        <Row>
          <Col span={16}>
            <h2>Component Process Flow</h2>
            <label>Add List of Processes</label>
            <br></br>
            <label>Process </label>
            <br></br>
            <Select
              name="process_name"
              onChange={processChange}
              placeholder="Please Select Process Name"
              style={{ width: "250px" }}
            >
              {dropDownOptions}
            </Select>
            <br></br>
            <label>Component Process Description</label>
            <Input
              name="process_desc"
              value={userInput.process_desc}
              onChange={handleChange}
            />

            <label>Operation No.</label>
            <Input
              name="operation_order"
              value={userInput.operation_order}
              onChange={handleChange}
            />
            <br></br>
            <br></br>
            <Button
              type="primary"
              shape="round"
              size="large"
              onClick={insertProcess}
            >
              Add Process
            </Button>
            <br></br>
            <ul className="processOrder">
              {list
                .sort((a, b) => a.rorder - b.rorder)
                .map((item) => (
                  <li key={item.id}>
                    <div className="processBar">
                      <div>
                        <button onClick={() => orderUp(item.id, item.rorder)}>
                          &uarr;
                        </button>
                      </div>
                      <div className="content">{item.processname}</div>
                      <div className="content">{item.processdesc}</div>
                      <div>
                        <button onClick={() => orderDown(item.id, item.rorder)}>
                          &darr;
                        </button>
                      </div>
                      <div>
                        <span
                          style={{
                            padding: "5px",
                            border: "1px solid #303030",
                            borderRadius: "3px",
                          }}
                        >
                          {item.rorder}
                        </span>
                      </div>
                      <div>
                        <button onClick={() => handleClick(item.id)}>X</button>
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
            <br></br>
            <br></br>
            <br></br>
            <Button
              type="primary"
              shape="round"
              size="large"
              onClick={handleSubmit}
            >
              Update Component
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ViewComponent;
